// proc chance ロール helper。ADR 0015 §4.2 / §7.2 / ADR 0014 §2.9 / §8.5。
//
// `Activation.onEvent` で発火する trigger / reactive Skill の確率ロールを担う。
// catalogue 投入 (ADR 0015) と同時に `reactive-events.ts` の発火パスに組み込まれ、
// active firing (`tick.ts` Step 4) の `jobTypeBonus.effectAmountMod` も近い形で扱う。
//
// proc chance 適用順 (ADR 0015 §7.2):
//   1. base = ItemSkill.values[tier] (tier 未設定なら values[0] fallback)
//   2. jobTypeBonus = caster.jobTypes が Activation.jobTypeBonus.jobType を保持していれば
//      Activation.jobTypeBonus.fireChanceMod、不一致なら 0
//   3. affix = 0 (4.5 affix で将来加算枠、本 PR では未投入)
//   4. sum = base + jobTypeBonus + affix
//   5. min(0.80, max(0, sum)) で 80% クランプ
//   6. rollProc(chance, rng) で発火可否を返す
/** §J #7 hard cap (発火率 80% 上限)。 */
export const PROC_CHANCE_CAP = 0.8;
/**
 * 合計を `[0, PROC_CHANCE_CAP]` にクランプ。負値は 0 に詰める。
 */
export function resolveProcChance(layers) {
    const sum = layers.base + layers.jobTypeBonus + layers.affix;
    if (sum <= 0)
        return 0;
    if (sum >= PROC_CHANCE_CAP)
        return PROC_CHANCE_CAP;
    return sum;
}
/**
 * `chance` の確率で `true` を返す。`chance >= 1` は常に `true`、`chance <= 0` は常に `false`。
 * `rng` は `[0, 1)` の浮動小数を返す関数 (Math.random or BattleState.rng)。
 */
export function rollProc(chance, rng) {
    if (chance >= 1)
        return true;
    if (chance <= 0)
        return false;
    return rng() < chance;
}
/**
 * `ItemSkill.values[tier]` を base proc chance として読み出す。
 * `tier` 未設定なら `values[0]` (T1) fallback、`values` 配列が空なら 0。
 */
export function readBaseProcChance(itemSkill) {
    const index = itemSkill.tier ?? 0;
    return itemSkill.values[index] ?? 0;
}
/**
 * `caster.jobTypes` が `activation.jobTypeBonus.jobType` を保持しているか判定。
 * `jobTypeBonus` 未設定なら常に `false` (= bonus 適用なし)。
 */
export function jobTypeMatches(activation, caster) {
    if (activation.jobTypeBonus === undefined)
        return false;
    return caster.jobTypes.has(activation.jobTypeBonus.jobType);
}
//# sourceMappingURL=proc-chance.js.map